// const LandingPageTitle = ({ record, translate, style }) => {
//   return (
//     <span style={style}>
//       {translate('LandingPage Name')} {record ? `"${record.name}"` : ''}
//     </span>
//   )
// }

export default {
  list: { lazy: () => import('./LandingPage'), component: 'LandingPageList' },
  create: { lazy: () => import('./LandingPage'), component: 'LandingPageCreate' },
  edit: { lazy: () => import('./LandingPage'), component: 'LandingPageEdit' },
}
